export default __webpack_public_path__ + "static/media/wR.edaded55.svg";